import { KUNDENLIST } from "../types";

const initialState = {   };

export default function (state = initialState, action:any) {
  const { type, payload } = action;

  switch (type) {
    case KUNDENLIST:
      return { ...payload };

    default:
      return state;
  }
}